$.Toast = function(message, position) {
    var $element = null;
    $element = $('<div class="toast-item-wrapper"></div>');
    $('<p class="toast-message">' + message + '</p>').appendTo($element);
    $element.appendTo("body");
    if(position === 'top') $element.css({ bottom: '45%'})
    if ($element.fadeIn) {
        $element.fadeIn();
    } else {
        $element.css({ display: 'block', opacity: 1 });
    }

    function removeToast() {
        $.Toast.remove($element);
    }
    setTimeout(removeToast, 2000);
    return $element;
}

$.Toast.remove = function($element) {
    "use strict";
    if ($element.fadeOut) {
        $element.fadeOut(function() {
            return $element.remove();
        });
    } else {
        $element.remove();
    }
}